import { useEffect, useState } from "react";
import { LuExternalLink, LuCheck, LuMessageSquare, LuStickyNote } from "react-icons/lu";
import * as styled from "./HomeworkCard.styled";

function HomeworkCard({
  teacherName,
  lessonDate,
  comment,
  url,
  lessonName,
  lessonType,
  commentForTeacher,
  setHomeworkOpen,
  lessonId,
  setLessonId,
  selectedLesson,
  getHomeworkText,
  homeworkOpen
}) {

  const [homeworkExists, setHomeworkExists] = useState(false);

  useEffect(() => {
    if (!teacherName) return;
    const fetchHomeworkText = async () => {
      try {
        const text = await getHomeworkText(lessonId);
        if (text.homeworkText || text.homeworkImages.length > 0) {
          setHomeworkExists(true);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchHomeworkText();
  }, [lessonId, getHomeworkText, teacherName]);

  if (lessonType === "failed-by-student") return;

  const toggleHomework = () => {
    setHomeworkOpen((prev) => !prev);
    setLessonId(lessonId);
  };

  return (
    <styled.LessonCard $open={lessonId === selectedLesson}>
      <styled.TopWrapper>
        {teacherName ? (
          <styled.NameWrapper>
            <styled.Avatar>{teacherName.trim().charAt(0).toUpperCase()}</styled.Avatar>
            <div>
              <styled.Caption>Вчитель</styled.Caption>
              <styled.NameText>{teacherName}</styled.NameText>
            </div>
          </styled.NameWrapper>
        ) : (
          <styled.TeacherHomeworkBtn onClick={toggleHomework} $active={lessonId === selectedLesson}>
            {lessonId === selectedLesson ? "Закрити" : "Перевірити ДЗ"}
          </styled.TeacherHomeworkBtn>
        )}
        <styled.DataWrapper>
          {homeworkExists && (
            <styled.Done>
              <LuCheck size={14} /> Здано
            </styled.Done>
          )}
          <styled.DataText>{new Date(lessonDate).toLocaleDateString("uk-UA")}</styled.DataText>
        </styled.DataWrapper>
      </styled.TopWrapper>

      <styled.BottomWrapper>
        {comment && (
          <styled.Note>
            <LuMessageSquare size={16} />
            <span>{comment}</span>
          </styled.Note>
        )}
        {commentForTeacher && (
          <styled.Note $muted>
            <LuStickyNote size={16} />
            <span>Помітка для себе: {commentForTeacher}</span>
          </styled.Note>
        )}

        <styled.Footer>
          <styled.LessonLink href={url} target="_blank" rel="noreferrer">
            <styled.LinkLabel>Матеріал уроку</styled.LinkLabel>
            <styled.LinkName>
              {lessonName} <LuExternalLink size={15} />
            </styled.LinkName>
          </styled.LessonLink>

          {teacherName && (
            <styled.HomeworkBtn onClick={toggleHomework} $secondary={homeworkExists || homeworkOpen}>
              {!homeworkOpen ? (homeworkExists ? "Переглянути ДЗ" : "Виконати ДЗ") : "Закрити"}
            </styled.HomeworkBtn>
          )}
        </styled.Footer>
      </styled.BottomWrapper>
    </styled.LessonCard>
  );
}

export default HomeworkCard;
